// Values must match the API-returned strings exactly (PascalCase as per agent service contract).
// Also used as i18n key fragments: t(`confidence.${value}`) — keep in sync with translations/en/main.json.
const confidenceLevelConstants = Object.freeze({
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
});

const accountingEditVariants = Object.freeze({
  BILL_MISSING: 'bill_missing',
  EXPENSE_DETAILS: 'expense_details',
  INVOICE_MATCHING: 'invoice_matching',
  VENDOR_MISSING: 'vendor_missing',
});

const billInvoiceSourceConstants = Object.freeze({
  BACKEND: 'backend',
  EPR: 'epr',
});

const billInvoiceStatusConstants = Object.freeze({
  CONFIRMED: 'confirmed',
  PAID: 'paid',
});

const billInvoiceSyncStatusConstants = Object.freeze({
  ALL: 'all',
  ERROR: 'error',
  IN_PROGRESS: 'in_progress',
  NONE: 'none',
  SUCCESS: 'success',
});

const journalEntryLevelConstants = Object.freeze({
  HEADER: 'H',
  LINES: 'L',
});

const customSegmentLevelTypeConstants = Object.freeze({
  VENDOR_BILL: 'levels_vendor_bill',
  JE: 'levels_je',
})

const journalEntryStatusesConstants = Object.freeze({
  ACTIVE: 'active',
  MISSING_DATA: 'missing_data',
  READY_FOR_REVIEW: 'ready_for_review',
  READY_FOR_SUBMISSION: 'ready_for_submission',
  SUBMITTED: 'submitted'
});

const journalEntrySyncStatusConstants = Object.freeze({
  ERROR: 'error',
  IN_PROGRESS: 'in_progress',
  SUCCESS: 'success',
});

const vendorSyncStatusConstants = Object.freeze({
  ALL: 'all',
  ERROR: 'error',
  IN_PROGRESS: 'in_progress',
  NONE: 'none',
  SUCCESS: 'success',
});

const vendorSourceConstants = Object.freeze({
  BACKEND: 'backend',
  M3G_NETSUITE: 'm3g_netsuite',
});

const suggestionRecordTypeConstants = Object.freeze({
  JOURNAL_ENTRY: 'journal_entry',
  VENDOR_BILL: 'vendor_bill',
  VENDOR: 'vendor',
});

// The shape a company's own ERP field takes. Only DROPDOWN carries a value list; the design
// labels it "Drop down", but the wire value is one word.
const customFieldTypeConstants = Object.freeze({
  DROPDOWN: 'dropdown',
  NUMBER: 'number',
  TEXT: 'text',
});

// Tab keys for the three accounting pages. Each page uses a subset — vendors and bills have their
// own ERP_* tab, journal entries have MISSING_BILLS and READY_TO_SYNC — but the shared keys have to
// agree, because export mode maps them to New / Registered from one place.
const accountingTabKeysConstants = Object.freeze({
  ERP_BILLS: 'erp_bills',
  ERP_VENDORS: 'erp_vendors',
  MISSING_BILLS: 'missing_bills',
  NOT_ON_ERP: 'not_on_erp',
  READY_TO_SYNC: 'ready_to_sync',
  SYNCED: 'synced',
});

const vendorCountryCategoryConstants = Object.freeze({
  DOMESTIC: 'DOMESTIC',
  INTRA_EU: 'INTRA_EU',
  NON_EU: 'NON_EU',
});

// Values of `netsuite_localisation` on the accounting company settings.
const netsuiteLocalisationConstants = Object.freeze({
  NEXIL: 'nexil',
  IAL: 'ial',
});

export {
  accountingEditVariants,
  confidenceLevelConstants,
  billInvoiceSourceConstants,
  billInvoiceStatusConstants,
  billInvoiceSyncStatusConstants,
  customSegmentLevelTypeConstants,
  journalEntryLevelConstants,
  journalEntryStatusesConstants,
  journalEntrySyncStatusConstants,
  vendorSyncStatusConstants,
  vendorSourceConstants,
  vendorCountryCategoryConstants,
  suggestionRecordTypeConstants,
  customFieldTypeConstants,
  accountingTabKeysConstants,
  netsuiteLocalisationConstants
};

